import { getErrorMessage } from '../../utils';
import {
  REQUEST_CREATE_SESSION,
  RECEIVE_CREATE_SESSION,
  SET_CREATE_SESSION_FAILURE,
  CLEAR_CREATE_SESSION_ERROR_MESSAGE,
} from '../constants/createSession';

const initialState = {
  isFetching: false,
  errorMessage: '',
};

const sessionCreation = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CREATE_SESSION: {
      return { ...state, isFetching: true };
    }
    case RECEIVE_CREATE_SESSION: {
      return { ...state, isFetching: false };
    }
    case SET_CREATE_SESSION_FAILURE: {
      const { error } = action;
      const errorMessage = getErrorMessage(error);
      return { ...state, isFetching: false, errorMessage };
    }
    case CLEAR_CREATE_SESSION_ERROR_MESSAGE: {
      return { ...state, errorMessage: '' };
    }
    default:
      return state;
  }
};

export default sessionCreation;
